import { Loteo_const } from './../../../models/loteo_const.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-loteo_const",
    templateUrl: "./loteo_const.component.html",
    styleUrls:['./loteo_const.component.css'],
    providers: [FormService]
})

export class Loteo_constComponent {
    @ViewChild('openModal') openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public actualRow2;
      public loteo_const: Loteo_const;
      public form;
      public temp_carct_loteo;
      public matcher = new FormService();


    constructor(private dialog: MatDialog){

        this.form = new FormGroup({

            const_simultanea: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("loteo_const"))){
            localStorage.setItem("loteo_const", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("loteo_const"));

            this.form.controls['const_simultanea'].setValue(this.rows[0]?this.rows[0].const_simultanea:'')

        }
        this.loteo_const = {const_simultanea:''};
    }

    add_loteo_const(){
        
        localStorage.setItem("loteo_const",JSON.stringify([]));
        this.actualRow = localStorage.getItem("loteo_const");

        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({

            const_simultanea: this.form.value.const_simultanea
            
        })
        localStorage.setItem("loteo_const", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("loteo_const");
        console.log(this.actualRow2)
      
        this.form.reset();//
    }


    cleanData(){
        this.temp_carct_loteo = {const_simultanea:""};
    }


    delete_loteo_const(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("loteo_const", JSON.stringify(this.rows));
            }
        }
    }

}